import { useTranslation } from "react-i18next";
import SocialLinks from "./SocialLinks";

export default function FooterBrand() {
  const { t } = useTranslation("landing");

  return (
    <div className="lg:col-span-1">
      {/* Logo */}
      <a
        href="/"
        aria-label="Rayabot"
        className="mb-5 inline-flex items-center gap-3 text-[20px] font-black tracking-tight sm:text-[22px]"
      >
        <div className="relative grid h-10 w-10 shrink-0 place-items-center overflow-hidden rounded-[14px] bg-gradient-to-br from-teal to-teal-2 text-[18px] font-black text-white shadow-[0_10px_24px_rgba(15,118,110,0.4)] sm:h-11 sm:w-11">
          R
          <span
            aria-hidden
            className="pointer-events-none absolute inset-0 -translate-x-full animate-shine bg-gradient-to-r from-transparent via-white/60 to-transparent"
          />
        </div>
        <span className="flex items-baseline text-ink">
          <span>{t("brand.part1")}</span>
          <span className="bg-gradient-to-br from-gold to-gold-2 bg-clip-text text-transparent">
            {t("brand.part2")}
          </span>
        </span>
      </a>

      {/* Desc */}
      <p className="mb-6 max-w-[320px] text-[14px] leading-[1.95] text-ink-soft">
        {t("footer.desc")}
      </p>

      {/* Socials */}
      <SocialLinks />
    </div>
  );
}